export enum RouteKeys {
  List = '/subscription-custom-plan-request',
  Edit = '/subscription-custom-plan-request/:id',
}
